import { Emitter } from './emitter';

class Location extends Emitter<number> {
  id: number | null = null;

  start() {
    this.id = navigator.geolocation.watchPosition(
      (position) => {
        this.emit(Math.round((position.coords.speed ?? 0) * 3.6));
      },
      null,
      { enableHighAccuracy: true },
    );
  }

  stop() {
    if (this.id !== null) {
      navigator.geolocation.clearWatch(this.id);
      this.id = null;
    }
  }
}

export default new Location();
